import type { BleDeviceInfoExtended } from '../../shared/interfaces/ble.interface';
import { DeviceType } from '../../shared/interfaces/ble.interface';

// Shared identity between the mock BLE facade and the Test-section activation effect so the
// settings screen, device card and persisted product all agree on the same fake Cannes device.
export const MOCK_HUNTING_DEVICE_ID = 'mock-cannes-device';
export const MOCK_HUNTING_DEVICE_NAME = 'Cannes (Mock)';
export const MOCK_HUNTING_DEVICE_SERIAL = 'MOCK-CANNES-0001';
// Never shown in the UI (see PersistedHuntingProduct) — any spec-compliant value works, the mock
// WiFi seams never actually associate with it. Not a real secret, dev-only fixture.
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const MOCK_HUNTING_DEVICE_ACCESS_POINT_PASSPHRASE = 'Mock-AP-Passphrase-1';

export const MOCK_HUNTING_DEVICE_INFO: BleDeviceInfoExtended = {
  deviceId: MOCK_HUNTING_DEVICE_ID,
  name: MOCK_HUNTING_DEVICE_NAME,
  isConnected: true,
  deviceType: DeviceType.CANNES,
};
